import React, { useEffect } from 'react';
import {
    Box,
    Typography,
    List,
    ListItem,
    Container,
    Divider,
} from '@mui/material';
// import { fetchQuestionsHandler } from '../ResponseHandlers/fetchQuestionsHandler';
// import { initGA, logPageView } from '../Tracking/GA4';

const HomePage = () => {
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             // Fetch data for selectedOption 0
    //             await fetchQuestionsHandler({ selectedOption: 0 });

    //             // Fetch data for StatePage in batches to manage concurrency
    //             const stateOptions = Array.from(
    //                 { length: 16 },
    //                 (_, i) => i + 1,
    //             ); // stateOptions: [ 1, 2, 3, ..., 16 ]
    //             const batchSize = 4; // Number of concurrent requests

    //             for (let i = 0; i < stateOptions.length; i += batchSize) {
    //                 const batch = stateOptions.slice(i, i + batchSize); // e.g., [1, 2, 3, 4], [5, 6, 7, 8], ...
    //                 await Promise.all(
    //                     batch.map((index) =>
    //                         fetchQuestionsHandler({
    //                             selectedOption: index,
    //                             usedPage: 'StatePage',
    //                         }),
    //                     ),
    //                 );
    //             }
    //         } catch (error) {
    //             console.error('Error fetching questions:', error);
    //         }
    //     };

    //     fetchData();
    // }, []);

    useEffect(() => {
        const mainElement = document.querySelector('main.MuiBox-root');
        if (mainElement) {
            mainElement.id = 'app-main';
        }
    }, []);

    // Window scroll control (better to use useEffect)
    useEffect(() => {
        const mainElement = document.querySelector('#app-main'); // Locate the window where scroll works
        if (mainElement) {
            mainElement.scrollTo({ top: 0, behavior: 'auto' });
        } else {
            // Fallback to window if container not found
            window.scrollTo({ top: 0, behavior: 'auto' });
        }
    }, []);

    return (
        <Box
            sx={{
                p: 2,
                textAlign: 'center',
                maxWidth: 600,
                margin: 'auto',
                mt: 3,
            }}
        >
            <Box
                component="img"
                src="https://upload.wikimedia.org/wikipedia/commons/8/8e/Flag_map_of_Germany.svg"
                alt="Logo"
                sx={{ width: 100, height: 100, mb: 2 }}
            />
            <Typography variant="h4" component="h1">
                Leben in Deutschland (Einbürgerungstest)
            </Typography>
            <Container sx={{ mt: 5 }}>
                <Typography variant="body1" gutterBottom>
                    Der Testbasis besteht aus 310 Fragen (aktualisiert am
                    Dezember 2024), davon:
                </Typography>
                {/* Correctly nest the List outside of any <p> tags */}
                <List>
                    <ListItem>300 allgemeine Fragen</ListItem>
                    <ListItem>
                        10 Fragen zum Bundesland, in dem du wohnst
                    </ListItem>
                </List>
                <Divider sx={{ my: 2 }} />
                {/* Avoid nesting <div> and <hr> inside <p> */}
                <Typography variant="body1" sx={{ mt: 2, textAlign: 'left' }}>
                    Hier können Sie an den Leben in Deutschland Prüfungs (LiD
                    oder Einbürgerungstest) üben, die allgemeine Fragen und
                    spezielle Fragen zu den einzelnen Bundesländern enthalten.
                </Typography>
                <Typography variant="body1" sx={{ textAlign: 'left', mt: 1 }}>
                    Falsche Antworten werden automatisch markiert und können
                    später auf der Startseite überprüft werden. Natürlich können
                    Sie Fragen auch selbst markieren und entfernen.
                </Typography>
            </Container>
        </Box>
    );
};

export default HomePage;
